module.exports = __webpack_public_path__ + "static/media/blog.c66382cc.png";